import apiClient from '../apiClient';
import type { BaseResponse, ListResponse, PaginationRequest } from '../../types/base.dto';

export interface DepositMainInfo {
  id: string;
  type?: string;
  from_to?: string;
  money?: string;
  after_num?: string;
  body?: string;
  order_id: string;
  order_no: string;
  trade_no?: string;
  from_log_id?: string;
  from_log_type?: string;
  name?: string;
  period?: string;
  created_at?: string;
  merch_name?: string;
}

export interface DepositFinancialItem {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  sourceId?: string;
  orderId?: string;
  status?: string;
  serverId?: string;
  main: DepositMainInfo;
}

export type DepositFinancialListRequest = PaginationRequest;
export type DepositFinancialSummaryRequest = PaginationRequest;

export interface DepositFinancialSummary {
  totalCount: number;
  totalAmount: number;
  offlineDeductAmount: number;
  platformSplitAmount: number;
  returnSplitAmount: number;
  alipayCommissionAmount: number;
  commissionNetAmount: number;
}

class DepositFinancialApi {
  async list(params: DepositFinancialListRequest): Promise<BaseResponse<ListResponse<DepositFinancialItem>>> {
    const response = await apiClient.post<BaseResponse<ListResponse<DepositFinancialItem>>>('/deposits/financial-list', params, {
      timeout: 100000,
    });
    return response.data;
  }

  async summary(params: DepositFinancialSummaryRequest): Promise<BaseResponse<DepositFinancialSummary>> {
    const response = await apiClient.post<BaseResponse<DepositFinancialSummary>>('/deposits/financial-summary', params, {
      timeout: 100000,
    });
    return response.data;
  }
}

export const depositFinancialApi = new DepositFinancialApi();

export default depositFinancialApi;
